import React from "react";

export type ChartPeriod = "today" | "week" | "month" | "year" | "all";

interface ChartFilterBarProps {
  value: ChartPeriod;
  onChange: (p: ChartPeriod) => void;
  /** Optional label shown before the buttons */
  label?: string;
}

const PERIODS: { key: ChartPeriod; label: string }[] = [
  { key: "today", label: "Today"   },
  { key: "week",  label: "Week"    },
  { key: "month", label: "Month"   },
  { key: "year",  label: "Year"    },
  { key: "all",   label: "All Time"},
];

const ChartFilterBar = ({ value, onChange, label }: ChartFilterBarProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 6,
      flexWrap: "wrap",
    }}
  >
    {label && (
      <span
        style={{
          fontSize: 12,
          color: "hsl(var(--muted-foreground))",
          fontWeight: 600,
          marginRight: 4,
        }}
      >
        {label}
      </span>
    )}
    {PERIODS.map((p) => {
      const active = value === p.key;
      return (
        <button
          key={p.key}
          onClick={() => onChange(p.key)}
          style={{
            padding: "5px 13px",
            borderRadius: 999,
            fontSize: 12,
            fontWeight: active ? 700 : 500,
            border: active
              ? "1.5px solid hsl(var(--primary))"
              : "1.5px solid hsl(var(--border))",
            background: active
              ? "hsl(var(--primary))"
              : "transparent",
            color: active
              ? "hsl(var(--primary-foreground))"
              : "hsl(var(--muted-foreground))",
            cursor: "pointer",
            transition: "all 160ms ease",
            whiteSpace: "nowrap",
            outline: "none",
          }}
          onMouseEnter={(e) => {
            if (!active) {
              (e.currentTarget as HTMLButtonElement).style.background =
                "hsl(var(--primary) / 0.1)";
              (e.currentTarget as HTMLButtonElement).style.color =
                "hsl(var(--foreground))";
            }
          }}
          onMouseLeave={(e) => {
            if (!active) {
              (e.currentTarget as HTMLButtonElement).style.background =
                "transparent";
              (e.currentTarget as HTMLButtonElement).style.color =
                "hsl(var(--muted-foreground))";
            }
          }}
        >
          {p.label}
        </button>
      );
    })}
  </div>
);

export default ChartFilterBar;
